import { render, staticRenderFns } from "./BeetweenInventory.vue?vue&type=template&id=615806b5&"
import script from "./BeetweenInventory.vue?vue&type=script&lang=js&"
export * from "./BeetweenInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports